export const IDENTIFIER_PATTERN = /^[a-z][a-z0-9_]*$/;
export const MAX_LABEL_LENGTH = 140;
export const MAX_DESCRIPTION_LENGTH = 250;
export const MAX_IDENTIFIER_LENGTH = 140;
export const MAX_OPTION_LENGTH = 140;

export const suggestIdentifierFrontend = (label: string): string => {
  const normalized = label
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/_+/g, '_');

  if (!normalized) {
    return 'field';
  }

  const startsWithLetter = /^[a-z]/.test(normalized);
  return startsWithLetter ? normalized : `field_${normalized}`;
};

interface ValidationResult {
  isValid: boolean;
  labelError?: string;
  identifierError?: string;
  optionsError?: string;
}

export const validateCustomFieldForm = (
  label: string,
  identifier: string,
  fieldType: 'TEXT' | 'SINGLE_SELECT',
  options: string[],
): ValidationResult => {
  const result: ValidationResult = { isValid: true };

  if (!label.trim()) {
    result.labelError = 'Label is required';
    result.isValid = false;
  }

  if (identifier && !IDENTIFIER_PATTERN.test(identifier)) {
    result.identifierError =
      'Identifier must start with a lowercase letter and contain only lowercase letters, numbers, and underscores';
    result.isValid = false;
  }

  if (fieldType === 'SINGLE_SELECT') {
    const nonEmptyOptions = options.filter((opt) => opt.trim());
    if (nonEmptyOptions.length === 0) {
      result.optionsError =
        'Single select fields must have at least one option';
      result.isValid = false;
    } else if (
      new Set(nonEmptyOptions.map((opt) => opt.toLowerCase())).size !==
      nonEmptyOptions.length
    ) {
      result.optionsError = 'Option labels must be unique';
      result.isValid = false;
    }
  }

  return result;
};
